import EventPage from 'organization/Event/EventPage'
import EventAttendantsProvider from 'organization/Event/Attendants/EventAttendantsProvider'
import EventStatisticsDashboard from 'organization/Event/Statistics/EventStatisticsDashboard'
import TicketSolds from 'organization/Event/Statistics/TicketSolds'
import React from 'react'

export const EventIndex = () => {
  return (
    <EventPage>
      <div className="row g-20 pl-30 pt-30 pb-30 pr-30">
        <EventStatisticsDashboard />
        <EventAttendantsProvider>
          <TicketSolds />
        </EventAttendantsProvider>
      </div>
    </EventPage>
  )
}
